module.exports = __webpack_public_path__ + "static/img/img-4-9.7518da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-9.png
// module id = VVfz
// module chunks = 0